module.exports = __webpack_public_path__ + "static/media/nima_talking_didi.748b4e78.gif";